module.exports = __webpack_public_path__ + "assets/apple-icon-144x144.c0adbb0b.png";